// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feed-container-vote-notice {
  margin: 12px 0 0;
  padding: 16px;
  border: 1px solid var(--border-color);
  border-radius: 18px;
  background:
    radial-gradient(circle at top left, color-mix(in srgb, var(--primary-color) 14%, transparent), transparent 45%),
    linear-gradient(180deg, var(--bg-secondary), var(--bg-primary));
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
}

.feed-container-vote-notice__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.feed-container-vote-notice__eyebrow {
  margin: 0 0 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.feed-container-vote-notice__title {
  margin: 0;
  font-size: 17px;
  line-height: 1.3;
  color: var(--text-primary);
}

.feed-container-vote-notice__title a {
  color: var(--primary-color);
  text-decoration: none;
}

.feed-container-vote-notice__title a:hover {
  text-decoration: underline;
}

.feed-container-vote-notice__dismiss {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: var(--hover-bg);
  color: var(--text-secondary);
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;
}

.feed-container-vote-notice__dismiss:hover {
  color: var(--text-primary);
}

.feed-container-vote-notice__body {
  margin: 12px 0 0;
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.5;
}

.feed-container-vote-notice__error {
  margin-top: 12px;
  color: #d14343;
  font-size: 13px;
}

.feed-container-vote-notice__quick-vote {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  flex-wrap: wrap;
}

.feed-container-vote-notice__toggle-btn {
  display: flex;
  align-items: center;
  color: var(--primary-color);
  border-color: var(--primary-color);
  background-color: transparent;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.feed-container-vote-notice__toggle-btn:hover {
  background-color: var(--primary-hover);
  color: var(--text-primary);
}
.feed-container-vote-notice__toggle-btn.expanded {
  background-color: color-mix(in srgb, var(--primary-color) 15%, transparent);
}
.feed-container-vote-notice__toggle-icon {
  margin-left: 4px;
  transition: transform 0.2s ease;
}
.feed-container-vote-notice__toggle-btn.expanded .feed-container-vote-notice__toggle-icon {
  transform: rotate(180deg);
}

.vote-dismiss-btn {
  border: none;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  margin-left: auto;
  transition: background 0.2s ease;
}
.vote-dismiss-btn:hover {
  background: var(--hover-bg);
}

.feed-container-vote-notice__slider {
  margin-top: 14px;
  position: relative;
}

.feed-container-vote-notice__slider .vote-slider-popup {
  position: static;
  width: 100%;
  padding: 14px;
  border-radius: 14px;
  box-shadow: none;
  background: color-mix(in srgb, var(--bg-secondary) 92%, white 8%);
}

.feed-container-vote-notice__slider .slider-actions {
  justify-content: flex-end;
}

@media (max-width: 768px) {
  .feed-container-vote-notice {
    margin: 12px 0 0;
    padding: 14px;
    border-radius: 16px;
  }

  .feed-container-vote-notice__title {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FeedContainerVoteNotice/FeedContainerVoteNotice.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB;;mEAEiE;EACjE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kCAAkC;EAClC,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,uDAAuD;AACzD;AACA;EACE,sCAAsC;EACtC,0BAA0B;AAC5B;AACA;EACE,2EAA2E;AAC7E;AACA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iEAAiE;AACnE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".feed-container-vote-notice {\r\n  margin: 12px 0 0;\r\n  padding: 16px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 18px;\r\n  background:\r\n    radial-gradient(circle at top left, color-mix(in srgb, var(--primary-color) 14%, transparent), transparent 45%),\r\n    linear-gradient(180deg, var(--bg-secondary), var(--bg-primary));\r\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.feed-container-vote-notice__header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n}\r\n\r\n.feed-container-vote-notice__eyebrow {\r\n  margin: 0 0 4px;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.feed-container-vote-notice__title {\r\n  margin: 0;\r\n  font-size: 17px;\r\n  line-height: 1.3;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.feed-container-vote-notice__title a {\r\n  color: var(--primary-color);\r\n  text-decoration: none;\r\n}\r\n\r\n.feed-container-vote-notice__title a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.feed-container-vote-notice__dismiss {\r\n  width: 32px;\r\n  height: 32px;\r\n  border: none;\r\n  border-radius: 50%;\r\n  background: var(--hover-bg);\r\n  color: var(--text-secondary);\r\n  font-size: 22px;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.feed-container-vote-notice__dismiss:hover {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.feed-container-vote-notice__body {\r\n  margin: 12px 0 0;\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.feed-container-vote-notice__error {\r\n  margin-top: 12px;\r\n  color: #d14343;\r\n  font-size: 13px;\r\n}\r\n\r\n.feed-container-vote-notice__quick-vote {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.feed-container-vote-notice__toggle-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  color: var(--primary-color);\r\n  border-color: var(--primary-color);\r\n  background-color: transparent;\r\n  padding: 8px 16px;\r\n  border-radius: 20px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease, color 0.2s ease;\r\n}\r\n.feed-container-vote-notice__toggle-btn:hover {\r\n  background-color: var(--primary-hover);\r\n  color: var(--text-primary);\r\n}\r\n.feed-container-vote-notice__toggle-btn.expanded {\r\n  background-color: color-mix(in srgb, var(--primary-color) 15%, transparent);\r\n}\r\n.feed-container-vote-notice__toggle-icon {\r\n  margin-left: 4px;\r\n  transition: transform 0.2s ease;\r\n}\r\n.feed-container-vote-notice__toggle-btn.expanded .feed-container-vote-notice__toggle-icon {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.vote-dismiss-btn {\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  border: 1px solid var(--border-color);\r\n  padding: 8px 16px;\r\n  border-radius: 20px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  margin-left: auto;\r\n  transition: background 0.2s ease;\r\n}\r\n.vote-dismiss-btn:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.feed-container-vote-notice__slider {\r\n  margin-top: 14px;\r\n  position: relative;\r\n}\r\n\r\n.feed-container-vote-notice__slider .vote-slider-popup {\r\n  position: static;\r\n  width: 100%;\r\n  padding: 14px;\r\n  border-radius: 14px;\r\n  box-shadow: none;\r\n  background: color-mix(in srgb, var(--bg-secondary) 92%, white 8%);\r\n}\r\n\r\n.feed-container-vote-notice__slider .slider-actions {\r\n  justify-content: flex-end;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .feed-container-vote-notice {\r\n    margin: 12px 0 0;\r\n    padding: 14px;\r\n    border-radius: 16px;\r\n  }\r\n\r\n  .feed-container-vote-notice__title {\r\n    font-size: 16px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
